import { Jwt, JwtPayload } from 'jsonwebtoken';
import $, { AxiosRequestConfig } from 'axios';
import { GetURI } from './utilities';

const BASEURL = `${GetURI()}/jwt`;

interface JWTSecurity {
    valid: boolean;
    expires: Date;
    signatureValid?: boolean;
    jwt: Jwt;
}

export class JwtHandler {
    public security: JWTSecurity;

    constructor(jwt: string) {
        this.security = this.validateJwt(jwt);
        if (this.security.valid) {
            this.security.signatureValid = false;
            this.validateJwtSignature(this.security.jwt).then((result) => {
                this.security.signatureValid = result;
            });
        }
        return this;
    }

    private decode(jt: string): Jwt | null {
        let jwt : Jwt = { header: { alg:'' }, payload: {}, signature: '' };
        jt = jt.replace('Bearer ', '');
        if (jt === '') {
            return null;
        } else {
            let sections = jt.split('.');
            if (sections.length !== 3) {
                return null;
            } else {
                jwt.header = JSON.parse(Buffer.from(sections[0], 'base64').toString());
                jwt.payload = JSON.parse(Buffer.from(sections[1], 'base64').toString());
                jwt.signature = sections[2];
            }
        }
        return jwt;
    }

    private validateJwt(jwt: string): JWTSecurity {
        try {
            const decoded = this.decode(jwt);
            if (decoded) {
                const jwtPayload = decoded.payload as JwtPayload;
                if (jwtPayload.exp) {
                    if (jwtPayload.exp < Date.now()) {
                        return { valid: false, expires: new Date(jwtPayload.exp), jwt: decoded };
                    } else {
                        return { valid: true, expires: new Date(), jwt: decoded };
                    }
                } else {
                    throw new Error('Invalid JWT');
                }
            } else {
                throw new Error('Invalid JWT');
            }
        } catch (error) {
            return { valid: false, expires: new Date(), jwt: { header: { alg:'' }, payload: {}, signature: '' } };
        }
    }

    private async validateJwtSignature(jwt: Jwt): Promise<boolean> {
        const axiosConfig : AxiosRequestConfig = {
            url: BASEURL,
            method: 'GET',
            headers: { 'Authorization': 'Signature ' + jwt.signature },
        };
        const resp = await $(axiosConfig);
        if (resp.status === 200) {
            return true;
        } else {
            return false;
        }
    }
}


